// extracted by mini-css-extract-plugin
export var checkboxInputRow = "K_vh";
export var checkboxInputColumn = "K_vj";
export var inputOptionRow = "K_qS";
export var inputOptionColumn = "K_qT";